<template>
  <div>
    <b-row class="m-0">
      <b-col sm="12" class="p-0">
        <div class="card bg-light mb-0">
          <div class="card-header bg-dark text-white">
              <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Add Preference</h6>
          </div>
          <div class="card-body p-2">
            <b-form @submit.prevent="save">
              <b-form-group
                label="Preference Description:"
                description="This field is required"
              >
                <b-form-input
                  v-model="form.description"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
              

              <div class="text-right">
                <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      mixins:[SwalMixin],
      props:{
          preference_form: {
              type: Object,
              default: () => {}
          },
          current_preference: {
              type: [Array, Object],
              default: () => []
          }
      },
      data() {
        return {
          form: {}
        }
      },
      created(){
        this.form=JSON.parse(JSON.stringify(this.preference_form));
      },
      methods: {
        save(){
          if(!this.validate())
          this.$emit('savePreference',this.form);
        },
        validate(){
          if(this.current_preference.find((x,index) => x.description === this.form.description && !x.is_deleted && this.preference_form.index_id!=index ) )
          {
            this.swal_transaction_error_data.text="Description already exist."
            this.swalRequestError();
            return true;
          }
        }
      }
    }
</script>
